import React from 'react';
export function PartnersSection() {
  const partners = ['Альянс ігрового захисту', 'Фонд правового захисту', 'Мережа відповідальної гри'];
  return <section className="py-20 bg-[#F5F0E8]" data-id="element-187">
      <div className="container mx-auto px-4" data-id="element-188">
        <div className="text-center mb-12" data-id="element-189">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-190">
            Наші чесні партнери
          </h2>
          <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full" data-id="element-191" />
        </div>

        <div className="flex flex-wrap justify-center gap-8 md:gap-16 items-center" data-id="element-192">
          {partners.map((partner, index) => <div key={index} className="flex flex-col items-center gap-4 group cursor-pointer" data-id="element-193">
              <div className="w-48 h-24 bg-white rounded-lg shadow-sm flex items-center justify-center p-4 border border-gray-100 group-hover:border-[#D4A843] transition-colors" data-id="element-194">
                {/* Placeholder Logo */}
                <div className="text-[#0A5E5C]/40 font-serif font-bold text-xl text-center group-hover:text-[#0A5E5C] transition-colors" data-id="element-195">
                  LOGO
                </div>
              </div>
              <span className="text-[#0A5E5C] font-medium text-sm text-center opacity-70 group-hover:opacity-100 transition-opacity" data-id="element-196">
                {partner}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}